import { render, staticRenderFns } from "./Manuals.vue?vue&type=template&id=6a0c87c2&scoped=true&"
import script from "./Manuals.vue?vue&type=script&lang=ts&"
export * from "./Manuals.vue?vue&type=script&lang=ts&"
import style0 from "./Manuals.vue?vue&type=style&index=0&id=6a0c87c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c87c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})
